import html2PDF from 'jspdf-html2canvas';

const buttonPDF = document.querySelector('.action-upload');
const page = document.querySelectorAll('body');

if(buttonPDF !== null){
    buttonPDF.addEventListener('click', function(){
        html2PDF(
            page,
            {
                margin: 0,
                filename: 'myfile.pdf',
                image: {type: 'jpeg',quality: 0.98},
                html2canvas: {scale: 2},
                jsPDF: {
                    unit: 'px',
                    format: 'letter',
                    orientation: 'portrait'
                }
            }
        );
    });
}